import { t } from "i18next";
import { useCallback, useState } from "react";
import { errorToast } from "../components/widgets/Toastify/Toastify";

interface Location {
  lat: number;
  lng: number;
  name: string;
}

export const useCurrentLocation = (prefill = false) => {
  const [location, setLocation] = useState<Location | null>(null);
  const [loading, setLoading] = useState(false);

  const fetchLocationName = async (lat: number, lng: number) => {
    try {
      const res = await fetch(
        `https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${lat}&lon=${lng}`
      );
      const data = await res.json();
      const city =
        data.address.city ||
        data.address.town ||
        data.address.village ||
        "Unknown";
      setLocation({ lat, lng, name: city });
    } catch (err) {
      console.error(err);
      errorToast(t("pages.currentlyReading.error.getLocationFailed"));
    }
  };

  const getLocation = useCallback(() => {
    if (!navigator.geolocation) {
      errorToast(t("pages.currentlyReading.error.geoUnsupported"));
      return;
    }
    setLoading(true);
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        const { latitude, longitude } = pos.coords;
        fetchLocationName(latitude, longitude).finally(() => setLoading(false));
      },
      (error) => {
        console.error(error);
        errorToast(t("pages.currentlyReading.error.getLocationFailed"));
        setLoading(false);
      }
    );
  }, []);

  const setLocationManually = useCallback((lat: number, lng: number) => {
    setLoading(true);
    fetchLocationName(lat, lng).finally(() => setLoading(false));
  }, []);

  if (prefill && !location && !loading) {
    getLocation();
  }

  return { location, loading, getLocation, setLocationManually };
};
